export default __webpack_public_path__ + "static/media/downloadtop.b9f0b44b.svg";